var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useLanguage } from '@base/LanguageProvider';
import FSButton from '@components/FSButton';
import { useUserActions } from '@data/hooks/usersAndGroups';
import SelectInput from '@shared/input/SelectInput';
import TextInput from '@shared/input/TextInput';
import { FlexRowRight } from '@styled/FlexWrappers';
import { ColorPalette, decimalSeparatorsByLocale } from '@util/enums';
import React, { useState } from 'react';
import { FeatureWrapper } from '../../base/FeatureWrapper';
import { useAuth } from '../../providers/AuthProvider';
export function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}
var defaultUser = {
    id: 0,
    keycloakId: '',
    firstName: '',
    lastName: '',
    email: '',
    avatar: null,
};
export function UserProfileInputs(_a) {
    var initialUser = _a.initialUser;
    var _b = useAuth(), currentUser = _b.user, userSettings = _b.settings;
    var updateUser = useUserActions().updateUser;
    var _c = useLanguage(), L = _c.L, changeLocalesAndPalette = _c.changeLocalesAndPalette;
    var _d = __read(useState(userSettings.user_app_language), 2), appLanguage = _d[0], setAppLanguage = _d[1];
    var _e = __read(useState(userSettings.user_currency_locale_locale), 2), currencyLocale = _e[0], setCurrencyLocale = _e[1];
    var _f = __read(useState(userSettings.user_date_locale), 2), dateLocale = _f[0], setDateLocale = _f[1];
    var _g = __read(useState(userSettings.user_color_palette), 2), colorPalette = _g[0], setColorPalette = _g[1];
    var _h = __read(useState(initialUser !== null && initialUser !== void 0 ? initialUser : defaultUser), 2), user = _h[0], setUser = _h[1];
    var _j = __read(useState({}), 2), invalid = _j[0], setInvalid = _j[1];
    if (!currentUser) {
        return null;
    }
    var onEmailChange = function (e) {
        setUser(__assign(__assign({}, user), { email: e.target.value }));
    };
    var onLastNameChange = function (e) {
        setUser(__assign(__assign({}, user), { lastName: e.target.value }));
    };
    var onFirstNameChange = function (e) {
        setUser(__assign(__assign({}, user), { firstName: e.target.value }));
    };
    var onCurrencyChange = function (e) {
        setCurrencyLocale(e.target.value);
    };
    var onLanguageChange = function (e) {
        setAppLanguage(e.target.value);
    };
    var onDateLocaleChange = function (e) {
        setDateLocale(e.target.value);
    };
    var onColorPaletteChange = function (e) {
        setColorPalette(e.target.value);
    };
    function validateInputs() {
        var newInvalid = {};
        if (user.email.trim() === '') {
            newInvalid.email = 'Please enter email address';
        }
        else if (!validateEmail(user.email)) {
            newInvalid.email = 'Please enter valid email address';
        }
        if (user.firstName.trim() === '') {
            newInvalid.firstName = 'Please enter first name';
        }
        if (user.lastName.trim() === '') {
            newInvalid.lastName = 'Please enter last name';
        }
        return newInvalid;
        // todo check if address is already used for new users
    }
    function done() {
        var _invalid = validateInputs();
        if (Object.keys(_invalid).length > 0) {
            setInvalid(_invalid);
        }
        else {
            updateUser(user);
            changeLocalesAndPalette({
                appLanguage: appLanguage,
                currencyLocale: currencyLocale,
                dateLocale: dateLocale,
                colorPalette: colorPalette,
            });
        }
    }
    function cancel() {
        setUser(initialUser !== null && initialUser !== void 0 ? initialUser : {
            id: 0,
            keycloakId: '',
            firstName: '',
            lastName: '',
            email: '',
            avatar: null,
        });
        setAppLanguage(userSettings.user_app_language);
        setCurrencyLocale(userSettings.user_currency_locale_locale);
        setDateLocale(userSettings.user_date_locale);
        setColorPalette(userSettings.user_color_palette);
    }
    var currOptions = decimalSeparatorsByLocale.map(function (opt) {
        return { label: opt.separator, value: opt.locale };
    });
    var dateLocaleOptions = [
        { label: 'American (12/31/2022)', value: 'en' },
        { label: 'German (31.12.2022)', value: 'de' },
    ];
    var colorOptions = [
        { label: 'Standard', value: ColorPalette.STANDARD },
        { label: 'Colorblind', value: ColorPalette.COLORBLIND },
    ];
    return (React.createElement("div", { style: { maxWidth: '600px' } },
        React.createElement("form", { className: "form-horizontal", onSubmit: done },
            React.createElement(FeatureWrapper, { featureKey: "canSeeCredentials" },
                React.createElement(TextInput, { label: L('Email'), value: user.email, name: "email", onChange: onEmailChange, invalidString: invalid.email ? invalid.email : '', bottomMargin: true }),
                React.createElement(TextInput, { label: L('First name'), value: user.firstName, name: "firstName", onChange: onFirstNameChange, invalidString: invalid.firstName ? invalid.firstName : '', bottomMargin: true }),
                React.createElement(TextInput, { label: L('Last name'), value: user.lastName, name: "lastName", onChange: onLastNameChange, invalidString: invalid.lastName ? invalid.lastName : '', bottomMargin: true })),
            React.createElement(SelectInput, { label: L('Decimal separator'), name: "currency", options: currOptions, value: currencyLocale, onChange: onCurrencyChange, bottomMargin: true, css: { marginTop: 30 } }),
            React.createElement(SelectInput, { label: L('Date format'), name: "dateLocale", options: dateLocaleOptions, value: dateLocale, onChange: onDateLocaleChange, bottomMargin: true }),
            React.createElement(SelectInput, { label: L('Chart color palette'), name: "palette", options: colorOptions, value: colorPalette, onChange: onColorPaletteChange, bottomMargin: true }),
            React.createElement(SelectInput, { label: L('App language'), name: "appLanguage", options: [
                    { label: 'English', value: 'en-US' },
                    { label: 'Croatian', value: 'hr-HR' },
                ], value: appLanguage, onChange: onLanguageChange, bottomMargin: true }),
            React.createElement(FlexRowRight, { style: { marginTop: 30 } },
                React.createElement(FSButton, { title: L('Cancel'), onClick: cancel, "$type": "secondary", style: { marginRight: 15 } }),
                React.createElement(FSButton, { title: L('Save'), onClick: done })))));
}
